import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { CPQScreenOption } from '../../../models/CPQUI';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css']
})
export class CheckboxComponent implements OnInit {
  @Output() OnCheckEmitter: EventEmitter<any> = new EventEmitter();
  CurrentScreenOption: CPQScreenOption;
  constructor() { }

  ngOnInit(): void {
  }

  SetControl(option: CPQScreenOption) {
    debugger;
    this.CurrentScreenOption = option;
  }

  onCheckChange(event: any, autoContinue: number) {
    this.CurrentScreenOption.Value = event.target.checked ? "True" : "False";
    this.OnCheckEmitter.emit(this.CurrentScreenOption)
  }
}
